export const Tables = {
  USERS: 'users',
  PROJECTS: 'projects',
  PROJECTS_TRANSLATIONS: 'projects_translations',
  PROJECT_IMAGES: 'project_images',
  TECHNOLOGIES: 'technologies',
  PROJECT_TECHNOLOGIES: 'project_technologies',
  EXPERIENCES: 'experiences',
  EXPERIENCES_TRANSLATIONS: 'experiences_translations',
  BLOG_POSTS: 'blog_posts',
  BLOG_POSTS_TRANSLATIONS: 'blog_posts_translations',
  TAGS: 'tags',
  BLOG_POST_TAGS: 'blog_post_tags',
  ACTIVITIES: 'activities',
  ACTIVITIES_TRANSLATIONS: 'activities_translations',
  SKILLS: 'skills',
  SKILLS_TRANSLATIONS: 'skills_translations',
  TECHNOLOGIES_TRANSLATIONS: 'technologies_translations',
  SERVICE_OFFERS: 'service_offers',
  CONTACT_MESSAGES: 'contact_messages',
  RATINGS: 'ratings',
};

export const ProjectTypes = {
  PROJECT: 'project',
  LAB: 'lab',
};

export const ActivityTypes = {
  CONFERENCE: 'conference',
  MEETUP: 'meetup',
  TRAINING: 'training',
  PUBLICATION: 'publication',
  PODCAST: 'podcast',
};

export const SkillLevels = {
  BEGINNER: 'Beginner',
  INTERMEDIATE: 'Intermediate',
  ADVANCED: 'Advanced',
  EXPERT: 'Expert',
};

export const RateableTypes = {
  PROJECT: 'project',
  BLOG_POST: 'blog_post',
};

export const LanguageCodes = {
  FR: 'fr',
  EN: 'en',
};
